/**
 * JIMMYJANE Article Shell — Interactive Features
 * ================================================
 * File: assets/jj-article.js
 * 
 * Features:
 *   1. Checklist item toggle (click to check/uncheck)
 *   2. Quick navigation dropdown (smooth scroll to sections)
 *
 * Loaded conditionally on blog article pages via:
 *   snippets/jj-article-scripts.liquid
 */

document.addEventListener("DOMContentLoaded", function () {

    /* ----------------------------------------
     Article meta pills (min read, updated, readers) from #article-meta
     ---------------------------------------- */
  var articleMeta = document.getElementById("article-meta");
  if (articleMeta && articleMeta.dataset) {
    var d = articleMeta.dataset;
    var readingEl = document.getElementById("jj-pill-reading-time");
    if (readingEl && d.readingTime) {
      readingEl.textContent = d.readingTime + " min read";
    }
    var updatedEl = document.getElementById("jj-pill-updated");
    if (updatedEl && d.updatedAt) {
      updatedEl.textContent = "Updated: " + d.updatedAt;
    }
    // var readersEl = document.getElementById("jj-pill-readers");
    // if (readersEl && d.readers) {
    //   readersEl.textContent = d.readers + " readers";
    // }
  }

  /* ----------------------------------------
     1. Interactive Checklist Toggles
     ---------------------------------------- */
  var checklistItems = document.querySelectorAll(".jj-article-checklist-item");
  checklistItems.forEach(function (item) {
    item.addEventListener("click", function () {
      this.classList.toggle("is-checked");
    });
  });

  /* ----------------------------------------
     2. Quick Navigation Dropdown
     ---------------------------------------- */
  var quickNav = document.getElementById("quick-nav");
  if (quickNav) {
    quickNav.addEventListener("change", function () {
      var target = this.value;
      if (target) {
        var element = document.querySelector(target);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
          // Reset select back to placeholder after navigating
          var self = this;
          setTimeout(function () {
            self.value = "";
          }, 100);
        }
      }
    });
  }

});
